export default __webpack_public_path__ + "static/media/sort.d4c7d063.svg";